<template>
  <div class="d-inline-flex align-items-center">
    <span v-if="hasTagSearchItems" class="cp position-relative" @click="openTagSearchModal">
      <small class="me-2">{{ label }}</small>
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" :fill="iconFill" class="bi bi-inbox" viewBox="0 0 16 16">
        <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438L14.933 9zM3.809 3.563A1.5 1.5 0 0 1 4.981 3h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z" />
      </svg>
      <span class="question-icon position-absolute">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" :fill="iconFill" class="bi bi-question" viewBox="0 0 16 16">
          <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
        </svg>
      </span>
    </span>

    <Modal
      v-if="showTagSearchModal"
      :size="'xl'"
      :modal_id="modalId"
      :title="title"
      :subtitle="subtitle"
      :decline_label="null"
      :lightLayout="false"
      :options="{ keyboard: false, backdrop: 'static' }"
      style="z-index: 999991"
      @hidden="closeTagSearchModal">
      <div class="pt-4" style="min-height: 60vh;">
        <MissingWorksWizard
          :selectableData="tagSearchItems"
          :open="showTagSearchModal"
          :selected="selectedTagPrescriptionTestId"
        >
        </MissingWorksWizard>
      </div>
    </Modal>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import Modal from "@/components/Modal/Standard";
import MissingWorksWizard from "@/components/devices/MissingWorksWizard";

export default {
  name: "TagSearchAction",
  components: {
    Modal,
    MissingWorksWizard,
  },
  props: {
    tagSearchItems: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "ricerca tag",
    },
    title: {
      type: String,
      default: "Ricerca tag",
    },
    subtitle: {
      type: String,
      default: "Puoi visualizzare la posizione del tag associato alla lavorazione",
    },
    iconFill: {
      type: String,
      default: "white",
    },
    modalId: {
      type: String,
      default: "tag_search_modal",
    },
  },
  setup(props) {
    const showTagSearchModal = ref(false);
    const hasTagSearchItems = computed(() => props.tagSearchItems.length > 0);
    const selectedTagPrescriptionTestId = computed(() => {
      return props.tagSearchItems[0]?.prescription_test_id;
    });

    const openTagSearchModal = () => {
      showTagSearchModal.value = true;
    };

    const closeTagSearchModal = () => {
      showTagSearchModal.value = false;
    };

    return {
      showTagSearchModal,
      hasTagSearchItems,
      selectedTagPrescriptionTestId,
      openTagSearchModal,
      closeTagSearchModal,
    };
  },
};
</script>

<style lang="scss" scoped>
  .question-icon {
    right: -5px;
    top: -5px;
  }
</style>
